<template>
  <div class="choose-term">
    <Select
      v-model="termId"
      :clearable="clearable"
      placeholder="请选择学期"
      @on-change="onChange"
      @on-clear="onClear"
      @on-open-change="handleSchoolTermSelect"
    >
      <Option
        v-for="item in termList"
        :key="item.termId"
        :value="item.termId"
        >{{ item.yearName + item.termName }}</Option
      >
    </Select>
  </div>
</template>

<script>
import courseCenter from '@/request/courseCenter/index.js';
import { timeToTimestamp } from '@/utils/moment.js';
export default {
  name: 'chooseTerm',
  props: {
    schoolId: {
      type: [String, Number],
      default: '',
    },
    // 是否可以学全部
    selectAll: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      termId: "",
      termList: []
    }
  },
  watch: {
    schoolId: {
      handler(newVal, oldVal) {
        this.getTermList(newVal)
      },
      immediate: true
    }
  },
  created() {

  },
  methods: {
    handleSchoolTermSelect(status) {
      if (this.schoolId === '') {
        return this.$Message.error('请先选择学校！');
      }
    },
    onClear() {

      this.$emit('on-change', {
        termId: this.termId
      })
    },
    onChange() {
      this.$emit('on-change', {
        termId: this.termId
      })
    },
    // 请求学期列表
    async getTermList(schoolId) {
      this.termList = [];
      this.termId = ''
      const params = {
        orgId: schoolId
      };
      if (!this.schoolId) {
        return null
      }
      const res = await courseCenter.getyearTermsListByNew(params);
      if (res.status === 200 && res.message) {
        if (this.selectAll) {
          this.termList = [
            {
              termId: 'all',
              yearName: '',
              termName: '全部学期'
            }
          ];
        }

        res.message.forEach(item => {
          this.termList.push(item);
        });
        // 分班管理  设置当前自然时间的所在学期
        const nowTamp = new Date().getTime();
        this.termList.forEach(item => {
          if (item.termId != 'all') {
            const beginTamp = timeToTimestamp(item.beginDate);
            const endTamp = timeToTimestamp(item.endDate);
            if (beginTamp <= nowTamp && nowTamp <= endTamp) {
              this.termId = item.termId;
            }
          }
        });
        this.$emit('on-change', {
          termId: this.termId
        })
      }
    },
  }
}
</script>

<style>
</style>